import React from "react";
import {Box, Grid, Typography} from "@material-ui/core";
import TextField from "../molecules/TextField";

// resources
import { BloodTestFields } from '~/data/shop/bloodTestResult'
import InputField from "../atoms/InputField";
import {css} from "@emotion/react";
import {InputAdornment} from "@mui/material";

export const ExamResultField = React.memo(() => {
  return (
      <>
        <Typography css={header}><span>当てはまる項目の数値を入力してください</span></Typography>
        {
          BloodTestFields.map((field, index) =>
              <div key={index} css={{marginTop: '8px'}}>
                <Grid container flexDirection={'row'} alignItems='center'>
                  <Grid item flexShrink={1} css={{maxWidth: '30rem'}}>
                    <InputField
                        id={`result_${field.code}`}
                        name={`result[${field.code}]`}
                        label={field.label}
                        css={fieldStyle}
                        wrapperCss={{margin: '4px'}}
                        endAdornment={<InputAdornment position="end" css={adornmentStyle}>{ field.unit }</InputAdornment>}
                    />
                  </Grid>
                </Grid>
              </div>
          )
        }

      </>
  )
})

ExamResultField.displayName = 'ExamResultField'

const header = css`
  margin: 32px 0;
  span {
    font-size: 1.4rem;
    font-weight: 500;
  }
`

const adornmentStyle = css`
  margin-right: 1rem;
`

const fieldStyle = css`
  width: 100%;
  margin-top: 6px !important;
`